import React from "react";
import Button from "./Button";
import { AlertTriangle } from "../../icons";
/* ErrorState — Phase B primitive. Section-level failure.
   Visually similar to EmptyState but danger-toned + optional retry.
   Phase 3d: default icon is lucide AlertTriangle (was ⚠ Unicode).
   Phase 3e: default copy is English ("Something went wrong" / "Retry");
   callers can pass `lang` for the legacy IT default, or override
   title/retryLabel explicitly. */

const DEFAULTS_BY_LANG = {
  it: { title: "Qualcosa è andato storto", retry: "Riprova" },
  en: { title: "Something went wrong",      retry: "Retry"   },
} as const;

export default function ErrorState({
  icon,
  title,
  message,
  onRetry,
  retryLabel,
  lang,
  className = "",
  ...rest
}: any) {
  const resolvedLang: "it" | "en" =
    lang === "it" || lang === "en"
      ? lang
      : (typeof window !== "undefined" && ((window as any).__APP_LANG__ === "it" || (window as any).__APP_LANG__ === "en"))
        ? ((window as any).__APP_LANG__ as "it" | "en")
        : "en";
  const defaults = DEFAULTS_BY_LANG[resolvedLang];
  const resolvedTitle = title ?? defaults.title;
  const resolvedRetry = retryLabel ?? defaults.retry;
  return (
    <div className={`v2-error-state ${className}`.trim()} role="alert" {...rest}>
      <div className="v2-error-state__icon" aria-hidden="true">
        {icon !== undefined ? icon : <AlertTriangle size={24} />}
      </div>
      {resolvedTitle != null ? <div className="v2-error-state__title">{resolvedTitle}</div> : null}
      {message != null ? <div className="v2-error-state__message">{message}</div> : null}
      {onRetry ? (
        <div className="v2-error-state__action">
          <Button variant="secondary" size="sm" onClick={onRetry}>{resolvedRetry}</Button>
        </div>
      ) : null}
    </div>
  );
}
